<template>
	<div class="flex flex-col gap-4">
		<div class="flex items-start gap-2">
			<button
				type="button"
				aria-label="Back"
				class="flex size-8 shrink-0 items-center justify-center rounded-md bg-gray-100 hover:bg-gray-200"
				@click="handleGoBack"
			>
				<ChevronLeftIcon
					class="size-4 text-gray-900"
					aria-hidden="true"
				/>
			</button>
			<div>
				<h2 class="text-xl leading-7 font-semibold text-gray-900 md:text-2xl md:leading-8">
					Securely Checkout
				</h2>
				<p class="text-sm text-won-secondary md:text-base">
					Add your new payment info here
				</p>
			</div>
		</div>

		<div
			class="w-full divide-y divide-won-green overflow-hidden rounded-lg border border-gray-200 bg-white md:grid md:grid-cols-[2fr_3fr] md:divide-x md:divide-y-0"
		>
			<PremiumPlanColumn
				mode="summary"
				:default-open="false"
			/>
			<div class="px-6 py-6 md:px-8">
				<SubscriptionPaymentForm @payment-form:success="handleSuccess" />
			</div>
		</div>
	</div>
</template>

<script setup>
import { ChevronLeftIcon } from '@heroicons/vue/20/solid';

import PremiumPlanColumn from './purchase/pricing/premium-plan-column.vue';
import SubscriptionPaymentForm from './purchase/subscription/subscription-payment-form.vue';

/**
 * The checkout step. The order summary is the premium column in `summary` mode, so it shows
 * exactly the cycle and price chosen on the previous screen and never offers the toggle again.
 */
const emit = defineEmits(['selectedPackage', 'goback', 'subscribe']);

const handleGoBack = () => { emit('goback'); };
const handleSuccess = () => { emit('subscribe'); };
</script>
